import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { WorkOsWidgets, UserProfile, UserSecurity } from '@workos-inc/widgets';

import { useAuth } from '../../workos-auth';
import { updateCurrentUserAvatar } from '../../features/user/user.slice';
import { formatPicture } from '../../core/services/image.service';
import { DescriptionHeader } from '../../features/user/components/description-header';
import { catchError } from '../../core/catch-error';
import { uiStore } from '../../core/stores/ui-store';

export const ProfilePage: React.FC = observer(() => {
  const { getAccessToken } = useAuth();

  useEffect(() => {
    uiStore.pageTitle = {
      label: 'Personal settings',
    };

    return ()=> {
      uiStore.pageTitle = {
        label: "",
      };
    }
  });

  const handleProfilePhoto = async (file?: File) => {
    if (!file) {
      return;
    }

    const options = { width: 250, height: 250 };
    const frame = await formatPicture(file, options);
    updateCurrentUserAvatar({ file: frame }).catch((e) => {
      catchError(e);
    });
  };

  return (
      <WorkOsWidgets
        style={{ minHeight: '0rem' }}
        theme={{
          appearance: 'dark',
          hasBackground: false,
          accentColor: 'var(--accentColor)',
          radius: 'medium',
          fontFamily: 'Inter',
          grayColor: 'blue',
        }}
      >
        <DescriptionHeader title="Profile" description="Manage your profile" />

        <UserProfile authToken={getAccessToken} />

        <DescriptionHeader
          title="Password and authentication"
          description="Use email and password to log in to PRODUCER."
        />
        <UserSecurity authToken={getAccessToken} />
      </WorkOsWidgets>
  );
});
